@if (!configuration().shouldHideOuraDiscountItem) {
  <div
    class="cartItem"
    [class.cartItem___default]="!configuration().isAB344Active"
    [class.cartItem___AB344]="configuration().isAB344Active"
    [class.cartItem___blue]="configuration().hasBlueBackground"
  >
    <div class="cartItem__icon">
      @if (optional) {
        <app-checkbox color="white" [selected]="selected" (click)="toggleSelected.emit()" />
      }
      @if (!optional) {
        <img [src]="'/assets/img/icons/' + icon() + '.svg'" />
      }
    </div>

    <div class="cartItem__content">
      <div class="cartItem__title">
        @if (titleModifier) {
          <span class="cartItem__titleModifier"> {{ titleModifier | translate }}</span>
        }
        @if (item.quantity > 1) {
          {{ item.quantity }} x
        }
        {{ item.title }}
      </div>
      <div class="cartItem__description">
        @if (item.variant && item.key === ProductKey.THERMOMETER) {
          <span class="cartItem__infoVariant">{{
            'cart-variant-' + item.variant | translate
          }}</span>
        }
        @if (nextRenewalProduct) {
          {{ nextRenewalProduct.price | localize }}&#47;{{ nextRenewalProductDuration() }}
          <span class="cartItem__infoRenewal">{{ 'txt-billing-' + item.key | translate }}</span>
        }
        {{ item.description }}
      </div>
    </div>
    @if (showPrice) {
      <div class="cartItem__price">
        @if (item.price.discount) {
          <div class="cartItem__priceDiscount">
            {{ item.price | discount: 0 | localize }}
          </div>
        }
        <div class="cartItem__priceOriginal">
          {{ configuration().priceText }}
        </div>
      </div>
    }
  </div>
}
